import type { BaseHtmlAttributesProps } from '#types/base-html-attributes.type';

import type { PaginationProps } from './types/pagination.props';

import { Container } from './components/container';
import { PaginationProvider } from './context/pagination.provider';

/**
 * Pagination component that provides pagination controls and context to its children.
 *
 * @param children - The content to be rendered between the pagination controls.
 * @param placement - Determines where the pagination controls are rendered: 'top', 'bottom', or 'both'.
 * Defaults to 'bottom'.
 * @param props - Additional HTML attributes and pagination-specific props.
 *
 * @remarks
 * - Wraps its children with a `PaginationProvider` for context.
 * - Renders the `Container` component with pagination controls at the specified placement(s).
 */
export const Pagination = ({ children, placement = 'bottom', ...props }: BaseHtmlAttributesProps & PaginationProps) => {
  return (
    <PaginationProvider>
      {placement === 'top' || placement === 'both' ? (
        <Container
          {...props}
          position="top"
        />
      ) : null}
      <div className="grow">{children}</div>
      {placement === 'bottom' || placement === 'both' ? (
        <Container
          {...props}
          position="bottom"
        />
      ) : null}
    </PaginationProvider>
  );
};
